
// WebpackRequireFrom
typeof __webpack_require__ !== "undefined" && Object.defineProperty(__webpack_require__, "p", {
  get: function () {
try {
  if (typeof STATIC_BUCKET_URL !== "string") {
    throw new Error("WebpackRequireFrom: 'STATIC_BUCKET_URL' is not a string or not available at runtime. See https://github.com/agoldis/webpack-require-from#troubleshooting");
  }
  return STATIC_BUCKET_URL;
} catch (e) {
  if (!true) {
    console.error(e);
  }
  return "/packs/";
}
 },
  set: function (newPublicPath) {
    console.warn("WebpackRequireFrom: something is trying to override webpack public path. Ignoring the new value" + newPublicPath  + ".");
}
});